import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { TENANT_COMPANY_NAME, TENANT_COMPANY_CODE_SHORT, TENANT_LOGO_URL } from '../../../config/tenant';
import { LINKED_FORM_STYLES, FORM_RENDERERS, renderLinkedFormPages } from './linkedFormRenderers';

// Exact copy of server CSS styles from pdf_new_template.html.twig
const PDF_STYLES = `
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    body {
        font-family: Arial, sans-serif;
        font-size: 8.5pt;
        color: #000;
        background: white;
    }
    .pdf-container {
        width: 1016px;
        padding: 15px 20px;
        background: white;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    td, th {
        padding: 1px 3px;
        vertical-align: top;
    }
    .header-table {
        margin-bottom: 4px;
    }
    .header-table .logo {
        width: 110px;
    }
    .header-table .logo img {
        width: 100px;
    }
    .header-table .title-section {
        text-align: center;
    }
    .header-table .main-title {
        font-size: 13pt;
        font-weight: bold;
        text-transform: uppercase;
    }
    .header-table .sub-title {
        font-size: 18pt;
        font-weight: bold;
        text-transform: uppercase;
    }
    .info-table td {
        border: 1px solid #000;
        padding: 3px;
    }
    .info-table .label {
        font-weight: bold;
        width: 15%;
    }
    .info-table .value {
        width: 35%;
    }
    .section {
        border: 2px solid #000;
        margin-top: 5px;
    }
    .section-title {
        background-color: #000;
        color: #fff;
        font-weight: bold;
        padding: 3px;
        font-size: 10pt;
    }
    .section-content {
        padding: 4px;
    }
    .checkbox-item {
        margin-bottom: 2px;
    }
    .checkbox {
        display: inline-block;
        width: 9px;
        height: 9px;
        border: 1px solid #000;
        margin-right: 4px;
        position: relative;
        top: 1px;
    }
    .checkbox.checked {
        background-color: #000;
    }
    .checkbox-grid {
        table-layout: fixed;
    }
    .checkbox-grid td {
        vertical-align: top;
        width: 20%;
        border: 1px solid #000;
        padding: 2px;
    }
    .evaluation-table-final th, .evaluation-table-final td {
        border: 1px solid #000;
        padding: 1px 2px;
        font-size: 8pt;
        text-align: left;
    }
    .evaluation-table-final th {
        font-weight: bold;
        text-align: center;
    }
    .evaluation-table-final .eval-box {
        text-align: center;
        width: 18px;
    }
    .tasks-table {
        margin-bottom: 0;
        table-layout: fixed;
    }
    .tasks-table thead {
        display: table-header-group;
    }
    .tasks-table tbody {
        page-break-inside: auto;
    }
    .tasks-table tbody:last-of-type tr:last-child td {
        border-bottom: 1px solid #000 !important;
    }
    .tasks-table tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    .tasks-table td.activity-continuation {
        border-top: none !important;
    }
    .tasks-table tr.last-before-break td {
        border-bottom: 1px solid #000 !important;
    }
    .tasks-table th, .tasks-table td {
        border: 1px solid #000;
        padding: 3px;
        text-align: center;
        vertical-align: top;
    }
    .tasks-table th {
        background-color: #000;
        color: #fff;
        font-weight: bold;
        font-size: 10pt;
    }
    .tasks-table td {
        text-align: center;
        vertical-align: middle;
        font-weight: bold;
        padding: 4px 3px;
    }
    .tasks-table td.energy-column {
        text-align: left;
        vertical-align: top;
    }
    .tasks-table-body tbody tr:first-child td {
        border-top: 1px solid #000;
    }
    .energy-separator {
        border-top: 2px solid #000 !important;
    }
    .stop-notice {
        border: 2px solid #000;
        padding: 3px;
        text-align: center;
        font-weight: bold;
        margin-bottom: 3px;
    }
    .signoff-outer-table {
        border: 2px solid #000;
    }
    .signoff-column {
        width: 38%;
        vertical-align: top;
        padding: 0;
    }
    .signoff-title {
        background-color: #000;
        color: #fff;
        font-weight: bold;
        text-align: center;
        padding: 3px;
    }
    .signoff-table {
        width: 100%;
    }
    .signoff-table th, .signoff-table td {
        border: 1px solid #000;
        padding: 1px 2px;
        font-size: 7.5pt;
        text-align: left;
    }
    .signoff-table th {
        font-weight: bold;
        text-align: center;
    }
    .signoff-table .num {
        width: 8%;
        text-align: center;
        font-weight: bold;
    }
    .signoff-table .sig {
        width: 45%;
    }
    .signoff-table .initials {
        width: 47%;
        text-align: left;
        padding-left: 5px;
        font-size: 8px;
        vertical-align: middle;
    }
    .signoff-table .sig-cell {
        height: 18px;
        text-align: center;
        vertical-align: middle;
    }
    .signoff-table .sig-cell img {
        max-height: 22px;
        width: auto;
    }
    .energy-wheel-cell {
        width: 24%;
        text-align: center;
        vertical-align: top;
        border-left: 2px solid #000;
        border-right: 2px solid #000;
    }
    .energy-wheel-title {
        background-color: #000;
        color: #fff;
        font-weight: bold;
        text-align: center;
        padding: 3px;
        margin-bottom: 0;
    }
    .energy-wheel-content {
        text-align: center;
        padding: 5px;
    }
    .energy-wheel-cell img {
        width: 95%;
        height: auto;
        vertical-align: middle;
    }
    .footer-sig-table {
        margin-top: 3px;
    }
    .footer-sig-table th, .footer-sig-table td {
        border: 1px solid #000;
        padding: 3px;
        text-align: left;
        font-size: 8.5pt;
    }
    .footer-sig-table th {
        background-color: #000;
        color: #fff;
        font-weight: bold;
        text-align: center;
    }
    .footer-sig-table td {
        height: 22px;
        vertical-align: bottom;
    }
    .footer-sig-table td.label {
        padding-bottom: 12px;
    }
    .footer-sig-table .sig-img {
        max-height: 24px;
        width: auto;
    }
    .signature-info {
        font-size: 6.5pt;
        color: #555;
        margin-top: 2px;
    }
    .checklist-table th, .checklist-table td {
        border: 1px solid #000;
        padding: 1px 2px;
        font-size: 8pt;
    }
    .checklist-table th {
        font-weight: bold;
        text-align: center;
    }
    .checklist-table .eval-box {
        text-align: center;
        width: 18px;
    }
    .page-break {
        page-break-after: always;
        height: 1px;
    }
`;

function formatDate(dateStr) {
    if (!dateStr) return '';
    // Date-only "YYYY-MM-DD" values must be formatted straight from their parts.
    // `new Date("2026-06-08")` parses as UTC midnight and then renders as the
    // previous day in any timezone west of UTC (e.g. 06/07 on a US Eastern iPad).
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateStr).trim());
    if (dateOnly) return `${dateOnly[2]}/${dateOnly[3]}/${dateOnly[1]}`;
    try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    } catch {
        return dateStr;
    }
}

function formatDateTime(dateStr) {
    if (!dateStr) return '';
    try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
    } catch {
        return dateStr;
    }
}

function distributeToColumns(items, numCols = 5) {
    const cols = Array.from({ length: numCols }, () => []);
    items.forEach((item, idx) => {
        cols[idx % numCols].push(item);
    });
    return cols;
}

function batchArray(arr, size) {
    const batches = [];
    for (let i = 0; i < arr.length; i += size) {
        batches.push(arr.slice(i, i + size));
    }
    return batches;
}

function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

// Classify a stepTwo document as one of the special safety forms (FARP/CSEP/LTT),
// or null for a generic document. Forms — whether filled digitally OR completed by
// hand and photographed — get their own full readable page in the PDF (not a tiny
// thumbnail). Generic docs stay in the compact ATTACHED DOCUMENTS grid.
function formTypeOfDoc(d) {
    const v = (d.value || d.customDocumentName || '').toLowerCase();
    if (d.specialType === 'csep' || v.includes('confined space')) return 'csep';
    if (d.specialType === 'ltt' || v.includes('lockout') || v.includes('lock-tag') || v.includes('lock tag') || v.includes('lock/tag')) return 'ltt';
    if (v.includes('fall arrest') || v.includes('rescue plan')) return 'farp';
    return null;
}

export function buildJhaPdfHtml(jhaData, crewMembers = [], options = {}) {
    const stepOne = jhaData.stepOne || {};
    const stepTwo = jhaData.stepTwo || {};
    const stepThree = jhaData.stepThree || {};
    const stepFour = jhaData.stepFour || {};
    const stepFive = jhaData.stepFive || {};

    const isSubmitted = !!jhaData.submittedAt || !!stepFive.submittedAt || !!stepFive.completedAt || jhaData.status === 'finish' || jhaData.status === 'completed';
    const mode = stepOne.mode || jhaData.mode || 'job';
    // 'manual' — та же локация, только вбитая руками: в шапке PDF ведёт себя как 'location'
    const isLocationBased = mode === 'location' || mode === 'manual';

    // Image paths - use local public folder for offline support
    const logoUrl = options.logoUrl || TENANT_LOGO_URL;
    const energyWheelUrl = options.energyWheelUrl || '/images/energy_wheel.png';

    // ========== WORK ACTIVITIES (unique from energyActivityRows) ==========
    const workActivities = [];
    const energyRows = stepThree.energyActivityRows || stepThree.energyExposures || [];

    // Extract unique work activities from rows
    energyRows.forEach(row => {
        const activity = row.workActivity || '';
        if (activity && !workActivities.includes(activity)) {
            workActivities.push(activity);
        }
    });

    // Also check stepThree.workActivities if it's an array of strings
    if (Array.isArray(stepThree.workActivities)) {
        stepThree.workActivities.forEach(item => {
            const activity = typeof item === 'string' ? item : (item.value || item.name || '');
            if (activity && !workActivities.includes(activity)) {
                workActivities.push(activity);
            }
        });
    }

    const workActivityCols = distributeToColumns(workActivities, 5);

    // ========== EVALUATIONS (from stepOne.evaluationOfWork) ==========
    const evaluationRows = [];
    const evalOfWork = stepOne.evaluationOfWork || [];
    evalOfWork.forEach(item => {
        if (item.value && item.selected) {
            evaluationRows.push({
                label: item.value,
                response: item.selected.toLowerCase()
            });
        }
    });
    const evaluationChunks = batchArray(evaluationRows, 3);

    // ========== SELECTED HAZARDS (short names for page 1) ==========
    const selectedHazards = [];
    energyRows.forEach(row => {
        const selections = row.energySelections || [];
        selections.forEach(sel => {
            (sel.hazards || []).forEach(hazard => {
                const hazardName = hazard.value || hazard.name || '';
                if (hazardName) {
                    const hazardShort = hazardName.split(':')[0].trim();
                    if (hazardShort && !selectedHazards.includes(hazardShort)) {
                        selectedHazards.push(hazardShort);
                    }
                }
            });
        });
    });
    const hazardCols = distributeToColumns(selectedHazards, 5);

    // ========== REQUIRED DOCS ==========
    const requiredDocs = [];
    const allDocs = [...(stepTwo.docsPermits || []), ...(stepTwo.customDocsPermits || [])];
    allDocs.forEach(doc => {
        if (doc.required === 'Yes Req') {
            const docName = doc.value || doc.customDocumentName || '';
            if (docName && !requiredDocs.includes(docName)) {
                requiredDocs.push(docName);
            }
        }
    });
    const docsCols = distributeToColumns(requiredDocs, 5);

    // ========== GROUP BY ACTIVITY FOR TASKS TABLE ==========
    const groupedByActivity = {};
    energyRows.forEach(row => {
        const activity = row.workActivity || 'Unspecified';
        if (!groupedByActivity[activity]) {
            groupedByActivity[activity] = [];
        }

        const selections = row.energySelections || [];
        if (selections.length === 0) {
            // No selections, add empty entry
            groupedByActivity[activity].push({
                energyName: '',
                energyDesc: '',
                hazards: []
            });
        } else {
            selections.forEach(sel => {
                const energyName = sel.energyName || sel.energy?.value || '';
                const energyDesc = sel.energy?.description || '';
                groupedByActivity[activity].push({
                    energyName,
                    energyDesc,
                    hazards: sel.hazards || []
                });
            });
        }
    });

    // ========== CREW SPLIT (only actual members, split in half) ==========
    const halfPoint = Math.ceil(crewMembers.length / 2);
    const crewLeft = crewMembers.slice(0, halfPoint);
    const crewRight = crewMembers.slice(halfPoint);

    // ========== POST-SHIFT CHECKLIST ==========
    const checklistData = stepFive.checklist || {};
    const checklistItems = [
        { id: 'injuryFree', label: 'Injury Free' },
        { id: 'incidentFree', label: 'Incident Free' },
        { id: 'incidentFormCompleted', label: 'Incident/Injury Form Completed' },
        { id: 'planReviewed', label: 'Plan Revised/Reviewed with Crew' },
        { id: 'equipmentInspected', label: 'Equipment Inspection(s) Completed' },
        { id: 'toolInspected', label: 'Tool Inspection(s) Completed' },
        { id: 'riggingInspected', label: 'Rigging Inspection(s) Completed' },
        { id: 'safetyEquipmentInspected', label: 'Safety Equipment Inspection(s) Completed' },
        { id: 'barricadesInPlace', label: 'Barricades In Place at end shift' },
        { id: 'barricadesRemoved', label: 'Barricades Removed at end shift' },
        { id: 'housekeepingComplete', label: 'Site Housekeeping Complete' }
    ];

    const checklistRows = checklistItems.map(item => {
        const val = checklistData[item.id];
        let response = null;
        if (val === true || val === 'true' || val === 1 || val === '1' || val === 'yes') {
            response = 'yes';
        } else if (val === false || val === 'false' || val === 0 || val === '0' || val === 'no') {
            response = 'no';
        }
        return { label: item.label, response };
    });
    const checklistChunks = batchArray(checklistRows, 3);
    const hasChecklist = checklistRows.some(r => r.response !== null);
    const postShiftComments = stepFive.comments || '';

    // ========== BUILD HTML ==========
    let html = `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>JHA</title>
    <style>${PDF_STYLES}</style>
    <style>${LINKED_FORM_STYLES}</style>
</head>
<body>
<div class="pdf-container">`;

    // ==================== PAGE 1 ====================
    html += `<div class="page-1">`;

    // Header
    html += `
    <table class="header-table">
        <tr>
            <td class="logo"><img src="${logoUrl}" alt="Logo"></td>
            <td class="title-section">
                <div class="main-title">${TENANT_COMPANY_NAME}</div>
                <div class="sub-title">Job Hazard Analysis (JHA)</div>
            </td>
        </tr>
    </table>`;

    // Info Table
    html += `
    <table class="info-table">
        <tr>
            <td class="label">Project #:</td>
            <td class="value">${isLocationBased ? '—' : escapeHtml(stepOne.jobNumber || '')}</td>
            <td class="label">Project Name:</td>
            <td class="value">${isLocationBased ? '—' : escapeHtml(stepOne.jobSiteName || '')}</td>
        </tr>
        <tr>
            <td class="label">Date:</td>
            <td class="value">${formatDate(stepOne.date)}</td>
            <td class="label">Task Location:</td>
            <td class="value">${escapeHtml(isLocationBased ? (stepOne.locationName || '') : (stepOne.jobSiteAddress || stepOne.taskLocation || ''))}</td>
        </tr>
        <tr>
            <td class="label">Supervisor Name:</td>
            <td class="value">${escapeHtml(stepOne.jobSiteSupervisor || '')}</td>
            <td class="label">${TENANT_COMPANY_CODE_SHORT} Company/Sub Name:</td>
            <td class="value"></td>
        </tr>
    </table>`;

    // WORK ACTIVITIES
    html += `
    <div class="section">
        <div class="section-title">WORK ACTIVITIES</div>
        <div class="section-content">`;

    if (workActivities.length > 0) {
        html += `<table class="checkbox-grid" style="table-layout: fixed;"><tr>`;
        for (let i = 0; i < 5; i++) {
            html += `<td style="width: 20%;">`;
            (workActivityCols[i] || []).forEach(act => {
                html += `<div class="checkbox-item"><span class="checkbox checked"></span>${escapeHtml(act)}</div>`;
            });
            html += `</td>`;
        }
        html += `</tr></table>`;
    } else {
        html += `<p>No work activities recorded.</p>`;
    }
    html += `</div></div>`;

    // EVALUATION OF WORK AREA
    if (evaluationRows.length > 0) {
        html += `
    <div class="section">
        <div class="section-title">EVALUATION OF WORK AREA</div>
        <div class="section-content">
            <table class="evaluation-table-final">
                <tr>
                    <th></th><th>Y</th><th>N/A</th>
                    <th></th><th>Y</th><th>N/A</th>
                    <th></th><th>Y</th><th>N/A</th>
                </tr>`;
        evaluationChunks.forEach(chunk => {
            html += `<tr>`;
            for (let i = 0; i < 3; i++) {
                const item = chunk[i];
                if (item) {
                    const isYes = item.response === 'yes';
                    const isNA = item.response === 'n/a' || item.response === 'na';
                    html += `
                    <td>${escapeHtml(item.label)}</td>
                    <td class="eval-box"><span class="checkbox${isYes ? ' checked' : ''}"></span></td>
                    <td class="eval-box"><span class="checkbox${isNA ? ' checked' : ''}"></span></td>`;
                } else {
                    html += `<td></td><td></td><td></td>`;
                }
            }
            html += `</tr>`;
        });
        html += `</table></div></div>`;
    }

    // POTENTIAL HAZARDS
    html += `
    <div class="section">
        <div class="section-title">POTENTIAL HAZARDS</div>
        <div class="section-content">`;

    if (selectedHazards.length > 0) {
        html += `<table class="checkbox-grid" style="table-layout: fixed;"><tr>`;
        for (let i = 0; i < 5; i++) {
            html += `<td style="width: 20%;">`;
            (hazardCols[i] || []).forEach(h => {
                html += `<div class="checkbox-item"><span class="checkbox checked"></span>${escapeHtml(h)}</div>`;
            });
            html += `</td>`;
        }
        html += `</tr></table>`;
    } else {
        html += `<p>No hazards recorded.</p>`;
    }
    html += `</div></div>`;

    // DOCS/PERMITS REQUIRED
    html += `
    <div class="section">
        <div class="section-title">DOCS/PERMITS REQUIRED</div>
        <div class="section-content">`;

    if (requiredDocs.length > 0) {
        html += `<table class="checkbox-grid" style="table-layout: fixed;"><tr>`;
        for (let i = 0; i < 5; i++) {
            html += `<td style="width: 20%;">`;
            (docsCols[i] || []).forEach(d => {
                html += `<div class="checkbox-item"><span class="checkbox checked"></span>${escapeHtml(d)}</div>`;
            });
            html += `</td>`;
        }
        html += `</tr></table>`;
    } else {
        html += `<p>No documents/permits required.</p>`;
    }
    html += `</div></div>`;

    html += `</div>`; // End page-1

    // ==================== PAGE 2+ (TASKS TABLE with page breaks) ====================

    // Height estimation functions (matching server logic)
    const estimateRowHeight = (hazard) => {
        const hazardText = hazard.value || hazard.name || '';
        // Hazards column: 30% width, 8pt font = ~55 chars per line
        const hazardLines = Math.ceil(hazardText.length / 55) || 1;

        const actions = [];
        if (hazard.preventHazards && hazard.preventHazards.length > 0) {
            hazard.preventHazards.forEach(p => {
                const pText = typeof p === 'string' ? p : (p.value || p.name || '');
                if (pText && pText.trim()) actions.push(pText.trim());
            });
        }
        const actionText = actions.join(', ');
        // Actions column: 30% width, 7.5pt font = ~58 chars per line
        const actionLines = Math.ceil(actionText.length / 58) || 1;

        const rowHeight = Math.max(hazardLines, actionLines);
        // Add constant buffer for padding/borders
        return rowHeight > 1 ? rowHeight + 0.3 : 1.3;
    };

    const estimateEnergyBlockHeight = (exp) => {
        const energyName = exp.energyName || '';
        const energyDesc = exp.energyDesc || '';
        // Energy column: 15% width, 8.5pt bold font = ~25 chars per line
        const energyNameLines = Math.ceil(energyName.length / 25) || 1;
        // Energy description: 7.5pt italic font = ~30 chars per line
        const energyDescLines = Math.ceil(energyDesc.length / 30) || 0;
        let energyCellHeight = energyNameLines + energyDescLines;
        if (energyCellHeight > 0) energyCellHeight += 0.3;

        let hazardsTotalHeight = 0;
        if (exp.hazards && exp.hazards.length > 0) {
            exp.hazards.forEach(hazard => {
                hazardsTotalHeight += estimateRowHeight(hazard);
            });
        } else {
            hazardsTotalHeight = 1.3;
        }

        return Math.max(energyCellHeight, hazardsTotalHeight);
    };

    const PAGE_MAX_HEIGHT = 46; // Same as server
    let accumulatedHeight = 0;
    let currentPageNum = 2;

    const renderTableHeader = () => `
    <table class="tasks-table">
        <thead>
            <tr>
                <th style="width: 25%;">Description Of Task To Be Performed</th>
                <th style="width: 15%;">Energy Wheel Classification</th>
                <th style="width: 30%;">Hazards Associated With Each Task</th>
                <th style="width: 30%;">Actions To Eliminate Or Control The Hazard</th>
            </tr>
        </thead>`;

    html += `<div class="page-2" style="margin-top: 20px;">`;

    const activities = Object.keys(groupedByActivity);

    if (activities.length > 0) {
        html += renderTableHeader();

        activities.forEach(activity => {
            const exposures = groupedByActivity[activity];

            // Calculate total hazards for this activity
            let totalHazardsInActivity = 0;
            exposures.forEach(exp => {
                totalHazardsInActivity += Math.max((exp.hazards || []).length, 1);
            });

            let activityPrinted = false;
            let printedHazards = 0;
            let energyIndex = 0;

            html += `<tbody class="activity-tbody">`;

            exposures.forEach((exp) => {
                const hazards = exp.hazards || [];
                const hazardsCount = Math.max(hazards.length, 1);
                const blockHeight = estimateEnergyBlockHeight(exp);

                // Check if we need a page break
                if (accumulatedHeight + blockHeight > PAGE_MAX_HEIGHT && accumulatedHeight > 0) {
                    html += `</tbody></table>`;
                    html += `</div>`; // End current page
                    html += `<div class="page-break"></div>`;
                    currentPageNum++;
                    html += `<div class="page-${currentPageNum}" style="margin-top: 20px;">`;
                    html += renderTableHeader();
                    html += `<tbody class="activity-tbody">`;
                    accumulatedHeight = 0;
                    activityPrinted = false; // Reset for new page
                }

                if (hazards.length > 0) {
                    hazards.forEach((hazard, hIdx) => {
                        html += `<tr>`;

                        // Activity cell - only on first row or after page break
                        if (!activityPrinted) {
                            const remainingHazards = totalHazardsInActivity - printedHazards;
                            html += `<td rowspan="${remainingHazards}" style="width: 25%;">${escapeHtml(activity || ' ')}</td>`;
                            activityPrinted = true;
                        }

                        // Energy cell - only on first hazard of this energy
                        if (hIdx === 0) {
                            const separatorClass = energyIndex > 0 ? ' energy-separator' : '';
                            html += `<td class="energy-column${separatorClass}" rowspan="${hazardsCount}" style="width: 15%;">
                                <strong>${escapeHtml(exp.energyName || '')}</strong>
                                ${exp.energyDesc ? `<br><em style="font-size: 7.5pt; font-weight: normal;">${escapeHtml(exp.energyDesc)}</em>` : ''}
                            </td>`;
                        }

                        // Hazard cell
                        const hazardName = hazard.value || hazard.name || '';
                        const hazardBorderStyle = energyIndex > 0 && hIdx === 0 ? 'border-top: 2px solid #000;' : '';
                        html += `<td style="font-size: 8pt; text-align: left; width: 30%; ${hazardBorderStyle}">${escapeHtml(hazardName)}</td>`;

                        // Actions cell
                        const actions = [];
                        if (hazard.preventHazards && hazard.preventHazards.length > 0) {
                            hazard.preventHazards.forEach(p => {
                                const pText = typeof p === 'string' ? p : (p.value || p.name || '');
                                if (pText && pText.trim()) actions.push(pText.trim());
                            });
                        }
                        html += `<td style="font-size: 7.5pt; width: 30%; ${hazardBorderStyle}">${actions.length > 0 ? escapeHtml(actions.join(', ')) : 'TBD'}</td>`;

                        html += `</tr>`;
                        printedHazards++;
                    });
                } else {
                    // No hazards - empty row
                    html += `<tr>`;
                    if (!activityPrinted) {
                        const remainingHazards = totalHazardsInActivity - printedHazards;
                        html += `<td rowspan="${remainingHazards}" style="width: 25%;">${escapeHtml(activity || ' ')}</td>`;
                        activityPrinted = true;
                    }
                    const separatorClass = energyIndex > 0 ? ' energy-separator' : '';
                    const borderStyle = energyIndex > 0 ? 'border-top: 2px solid #000;' : '';
                    html += `<td class="energy-column${separatorClass}" style="width: 15%;">
                        <strong>${escapeHtml(exp.energyName || '')}</strong>
                        ${exp.energyDesc ? `<br><em style="font-size: 7.5pt; font-weight: normal;">${escapeHtml(exp.energyDesc)}</em>` : ''}
                    </td>`;
                    html += `<td style="font-size: 8pt; text-align: left; width: 30%; ${borderStyle}"></td>`;
                    html += `<td style="font-size: 7.5pt; width: 30%; ${borderStyle}"></td>`;
                    html += `</tr>`;
                    printedHazards++;
                }

                accumulatedHeight += blockHeight;
                energyIndex++;
            });

            html += `</tbody>`;
        });

        html += `</table>`;
    } else {
        html += `
        <table class="tasks-table">
            <thead>
                <tr>
                    <th style="width: 25%;">Description Of Task To Be Performed</th>
                    <th style="width: 15%;">Energy Wheel Classification</th>
                    <th style="width: 30%;">Hazards Associated With Each Task</th>
                    <th style="width: 30%;">Actions To Eliminate Or Control The Hazard</th>
                </tr>
            </thead>
            <tbody>
                <tr><td colspan="4" style="text-align: center;">No data recorded.</td></tr>
            </tbody>
        </table>`;
    }

    // Estimate remaining content height (STOP NOTICE + crew + checklist + footer sigs = ~25-30 units)
    const remainingContentHeight = 28;
    if (accumulatedHeight + remainingContentHeight > PAGE_MAX_HEIGHT && accumulatedHeight > 5) {
        // Need page break before crew/footer content
        html += `</div>`; // End current page
        html += `<div class="page-break"></div>`;
        currentPageNum++;
        html += `<div class="page-${currentPageNum}" style="margin-top: 20px;">`;
    }

    // STOP NOTICE
    html += `
    <div class="stop-notice">
        Work shall STOP if/when conditions change, the task changes, or a deficiency in the original plan is discovered, and the current JHA will be modified or a new JHA will be created
    </div>`;

    // CREW SIGN-OFF + ENERGY WHEEL
    const hasCrewData = crewMembers.length > 0;
    const hasAnySignature = crewMembers.some(m => m?.signature);
    const showSignatures = isSubmitted || hasAnySignature;

    if (hasCrewData) {
        html += `<table class="signoff-outer-table"><tr>`;

        // Left column
        html += `<td class="signoff-column">
            <div class="signoff-title">${showSignatures ? 'PLAN REVIEW CREW SIGN-OFF' : 'PLAN REVIEW CREW LIST'}</div>
            <table class="signoff-table">
                <tr>
                    <th class="num"></th>
                    <th class="sig">${showSignatures ? 'CREW MEMBER SIGNATURE' : 'STATUS'}</th>
                    <th class="initials">FULL NAME</th>
                </tr>`;

        crewLeft.forEach((member, idx) => {
            // Show signature image if available, otherwise show status
            let sigContent;
            if (member?.signature) {
                sigContent = `<img src="${member.signature}" alt="Signature" style="max-height: 22px; width: auto;">`;
            } else if (showSignatures) {
                sigContent = ' ';
            } else {
                sigContent = '<span style="font-size: 8px; color: #666;">Pending</span>';
            }
            html += `<tr>
                <td class="num">${idx + 1}</td>
                <td class="sig-cell">${sigContent}</td>
                <td class="initials">${escapeHtml(member?.fullName || member?.employeeName || member?.name || '') || ' '}</td>
            </tr>`;
        });
        html += `</table></td>`;

        // Energy wheel
        html += `<td class="energy-wheel-cell">
            <div class="energy-wheel-title">ENERGY WHEEL</div>
            <div class="energy-wheel-content">
                <img src="${energyWheelUrl}" alt="Energy Wheel">
            </div>
        </td>`;

        // Right column
        html += `<td class="signoff-column">
            <div class="signoff-title">${showSignatures ? 'PLAN REVIEW CREW SIGN-OFF' : 'PLAN REVIEW CREW LIST'}</div>
            <table class="signoff-table">
                <tr>
                    <th class="num"></th>
                    <th class="sig">${showSignatures ? 'CREW MEMBER SIGNATURE' : 'STATUS'}</th>
                    <th class="initials">FULL NAME</th>
                </tr>`;

        crewRight.forEach((member, idx) => {
            // Show signature image if available, otherwise show status
            let sigContent;
            if (member?.signature) {
                sigContent = `<img src="${member.signature}" alt="Signature" style="max-height: 22px; width: auto;">`;
            } else if (showSignatures) {
                sigContent = ' ';
            } else {
                sigContent = '<span style="font-size: 8px; color: #666;">Pending</span>';
            }
            html += `<tr>
                <td class="num">${crewLeft.length + idx + 1}</td>
                <td class="sig-cell">${sigContent}</td>
                <td class="initials">${escapeHtml(member?.fullName || member?.employeeName || member?.name || '') || ' '}</td>
            </tr>`;
        });
        html += `</table></td>`;

        html += `</tr></table>`;
    } else {
        // No crew - show only Energy Wheel centered at normal size
        html += `<table class="signoff-outer-table"><tr>
            <td style="width: 38%;"></td>
            <td class="energy-wheel-cell" style="width: 24%;">
                <div class="energy-wheel-title">ENERGY WHEEL</div>
                <div class="energy-wheel-content">
                    <img src="${energyWheelUrl}" alt="Energy Wheel">
                </div>
            </td>
            <td style="width: 38%;"></td>
        </tr></table>`;
    }

    // ATTACHED DOCUMENTS — grouped per document so it's clear what belongs to what.
    // For each document with content we show a labeled block: the document name +
    // status, then either its photo(s)/file(s) or an inline preview of the linked
    // form (FARP/CSEP/LTT). Offline-safe: photo dataUrls and linked-form data are
    // already local (no network). The full linked-form PDF is also attached to email.
    {
        const docList = [...(stepTwo.docsPermits || []), ...(stepTwo.customDocsPermits || [])];
        // GENERIC docs only (with photo/file attachments). The special safety forms
        // (FARP/CSEP/LTT) are NOT shown here — they get their own full readable page(s)
        // below, whether filled digitally or completed by hand and photographed.
        const docsWithContent = docList.filter(d =>
            !formTypeOfDoc(d) && Array.isArray(d.attachments) && d.attachments.length > 0
        );
        if (docsWithContent.length > 0) {
            html += `<div class="section" style="margin-top: 6px;">
                <div class="signoff-title">ATTACHED DOCUMENTS</div>`;
            docsWithContent.forEach(d => {
                const name = escapeHtml(d.value || d.customDocumentName || 'Document');
                const atts = (Array.isArray(d.attachments) ? d.attachments : []).filter(a => a?.dataUrl);
                const reqLabel = d.required === 'Yes Req' ? 'Required' : (d.required === 'Not Req' ? 'Not required' : '');

                // Per-document block with a clear header.
                html += `<div style="margin-top:5px;border:1px solid #e0e0e0;border-radius:4px;padding:5px 7px;page-break-inside:avoid;">
                    <div style="display:flex;align-items:baseline;gap:6px;margin-bottom:3px;">
                        <span style="font-size:10px;font-weight:700;color:#263238;">${name}</span>
                        ${reqLabel ? `<span style="font-size:8px;color:#90a4ae;">(${reqLabel})</span>` : ''}
                        <span style="font-size:8px;color:#607d8b;margin-left:auto;">${atts.length} file${atts.length > 1 ? 's' : ''} attached</span>
                    </div>
                    <div style="display:flex;flex-wrap:wrap;gap:8px;">`;
                atts.forEach(att => {
                    const isImg = (att.mimeType || '').startsWith('image/') || /^data:image\//.test(att.dataUrl);
                    html += `<div style="width:300px;max-width:100%;">
                        ${isImg
                            ? `<img src="${att.dataUrl}" alt="${name}" style="width:100%;max-height:340px;object-fit:contain;border:1px solid #ccc;border-radius:3px;background:#fafafa;">`
                            : `<div style="height:110px;display:flex;align-items:center;justify-content:center;background:#f5f5f5;border:1px solid #ccc;border-radius:3px;font-size:9px;color:#555;text-align:center;padding:4px;">${escapeHtml(att.name || 'File')}</div>`}
                        <div style="font-size:8px;margin-top:1px;text-align:center;color:#607d8b;word-break:break-word;">${escapeHtml(att.name || '')}</div>
                    </div>`;
                });
                html += `</div></div>`;
            });
            html += `</div>`;
        }
    }

    // POST-SHIFT CHECKLIST (only if submitted)
    if (isSubmitted && hasChecklist) {
        html += `
    <div class="section" style="margin-top: 5px;">
        <div class="section-title">POST SHIFT CHECKLIST</div>
        <div class="section-content">
            <table class="evaluation-table-final">
                <tr>
                    <th></th><th>Y</th><th>N</th>
                    <th></th><th>Y</th><th>N</th>
                    <th></th><th>Y</th><th>N</th>
                </tr>`;
        checklistChunks.forEach(chunk => {
            html += `<tr>`;
            for (let i = 0; i < 3; i++) {
                const item = chunk[i];
                if (item) {
                    html += `
                    <td>${escapeHtml(item.label)}</td>
                    <td class="eval-box"><span class="checkbox${item.response === 'yes' ? ' checked' : ''}"></span></td>
                    <td class="eval-box"><span class="checkbox${item.response === 'no' ? ' checked' : ''}"></span></td>`;
                } else {
                    html += `<td></td><td></td><td></td>`;
                }
            }
            html += `</tr>`;
        });
        html += `</table>`;

        if (postShiftComments) {
            html += `<div style="margin-top: 5px; padding: 5px; border: 1px solid #ddd;">
                <strong>Comments:</strong> ${escapeHtml(postShiftComments)}
            </div>`;
        }
        html += `</div></div>`;
    }

    // FOOTER SIGNATURES - check all possible data locations
    const supervisorName = stepOne.jobSiteSupervisor || jhaData.jobSiteSupervisor || '';

    // Pre-shift signature
    const preShiftSig = stepThree.preShiftSignature
        || stepThree.preShiftSupervisorSignature
        || stepThree.supervisorSignature
        || stepFour.preShiftSupervisorSignature
        || jhaData.preShiftSupervisorSignature
        || stepThree.initialSubmission?.supervisorSignature
        || '';
    const preShiftDate = stepThree.preShiftSignedAt
        || stepThree.preShiftSupervisorSignedAt
        || stepFour.preShiftSupervisorSignedAt
        || jhaData.preShiftSupervisorSignedAt
        || stepThree.initialSubmission?.signedAt
        || stepThree.initialSubmission?.submittedAt
        || stepThree.initialSubmission?.createdAt
        || stepThree.submittedAt
        || stepOne.date
        || '';

    // Post-shift signature
    const postShiftSig = stepFive.supervisorSignature
        || stepFive.postShiftSupervisorSignature
        || jhaData.postShiftSupervisorSignature
        || '';
    const postShiftDate = stepFive.supervisorSignedAt
        || stepFive.postShiftSupervisorSignedAt
        || jhaData.postShiftSupervisorSignedAt
        || stepFive.submittedAt
        || stepFive.completedAt
        || '';

    // Safety signature
    const safetySig = stepFive.safetySignature
        || stepFive.safetyDepartmentSignature
        || jhaData.safetyDepartmentSignature
        || '';
    const safetyName = stepFive.safetyEmployee?.FullName
        || stepFive.safetyEmployeeName
        || jhaData.safetyDepartmentEmployeeName
        || '';
    const safetyDate = stepFive.safetySignedAt
        || stepFive.safetyDepartmentSignedAt
        || jhaData.safetyDepartmentSignedAt
        || '';

    console.log('PDF Generation Debug:', {
        isSubmitted,
        hasAnySignature,
        showSignatures,
        crewCount: crewMembers.length,
        preShiftSig: !!preShiftSig,
        preShiftDate,
        postShiftSig: !!postShiftSig,
        postShiftDate,
        safetySig: !!safetySig,
        hasChecklist,
        stepFiveCompletedAt: stepFive.completedAt
    });

    html += `
    <table class="footer-sig-table">
        <thead>
            <tr>
                <th>Safety Department Plan Review (If Applicable)</th>
                <th>Supervisor Pre-Shift Plan Review With Crew</th>
                <th>Supervisor Daily Completion Sign-Off</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="label">
                    ${safetySig ? `<img class="sig-img" src="${safetySig}" alt="Safety Signature" style="max-height: 24px; width: auto;">
                    <div class="signature-info"><strong>Signed by:</strong> ${escapeHtml(safetyName || 'Safety Dept')}${safetyDate ? ` | <strong>Date:</strong> ${formatDateTime(safetyDate)}` : ''}</div>` : 'Signature:'}
                </td>
                <td class="label">
                    ${preShiftSig ? `<img class="sig-img" src="${preShiftSig}" alt="Signature" style="max-height: 24px; width: auto;">
                    <div class="signature-info"><strong>Signed by:</strong> ${escapeHtml(supervisorName || 'N/A')}${preShiftDate ? ` | <strong>Date:</strong> ${formatDateTime(preShiftDate)}` : ''}</div>` : 'Signature:'}
                </td>
                <td class="label">
                    ${isSubmitted && postShiftSig ? `<img class="sig-img" src="${postShiftSig}" alt="Signature" style="max-height: 24px; width: auto;">
                    <div class="signature-info"><strong>Signed by:</strong> ${escapeHtml(supervisorName || 'N/A')}${postShiftDate ? ` | <strong>Date:</strong> ${formatDateTime(postShiftDate)}` : ''}</div>` : 'Signature:'}
                </td>
            </tr>
        </tbody>
    </table>`;

    // Footer (inside last page)
    const localId = jhaData.localId || jhaData.id || 'N/A';
    const now = new Date();
    const generated = `${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

    html += `
<div style="text-align: center; font-size: 7pt; color: #666; margin-top: 10px; border-top: 1px solid #ddd; padding-top: 5px;">
    Generated: ${generated} | ID: ${localId}
</div>`;

    html += `</div>`; // End last page (could be page-2, page-3, etc.)

    // ── Append the safety FORMS as their own full portrait pages ──────────────
    // Each form (FARP/CSEP/LTT) is rendered on its own readable page(s), either:
    //   • filled DIGITALLY (linked record) → pixel-faithful render from IDB data, OR
    //   • completed BY HAND and PHOTOGRAPHED → each photo on its own full page.
    // Continues the JHA page numbering so renderPdfFromHtml picks them up. Offline.
    {
        const linkedForms = options.linkedForms || {};
        const allDocsForForms = [...(stepTwo.docsPermits || []), ...(stepTwo.customDocsPermits || [])];
        const formItems = [];
        const seen = new Set();
        allDocsForForms.forEach(d => {
            const ft = formTypeOfDoc(d);
            if (!ft) return; // generic docs handled in the grid above

            const linkedUuid = d.linkedFarpUuid || d.linkedCsepUuid || d.linkedLttUuid || null;
            // Prefer the digital form when it's available locally.
            if (linkedUuid && FORM_RENDERERS[ft] && linkedForms[linkedUuid]) {
                if (seen.has(linkedUuid)) return;
                seen.add(linkedUuid);
                formItems.push({ type: ft, data: linkedForms[linkedUuid] });
                return;
            }
            // Otherwise render each attached photo of the form as its own full page.
            const label = d.value || d.customDocumentName || 'Document';
            (Array.isArray(d.attachments) ? d.attachments : []).forEach(att => {
                if (att?.dataUrl) formItems.push({ type: 'photo', title: label, dataUrl: att.dataUrl });
            });
        });
        if (formItems.length) {
            const { html: formsHtml } = renderLinkedFormPages(formItems, currentPageNum + 1, options);
            html += formsHtml;
        }
    }

    html += `</div></body></html>`;

    return html;
}

export async function generateJhaPdf(jhaData, crewMembers = [], filename = 'JHA.pdf', options = {}) {
    const html = buildJhaPdfHtml(jhaData, crewMembers, options);
    return await renderPdfFromHtml(html, filename, 'download');
}

/**
 * Render a SINGLE linked form (FARP/CSEP/LTT) to its own PDF blob — so it can be
 * previewed individually from the JHA documents list. Offline-safe (data comes
 * from IDB, no network). Returns a Blob, or null if no client renderer/data.
 *
 * @param {string} type - 'farp' | 'csep' | 'ltt'
 * @param {object} data - the full form record (from IDB)
 */
export async function generateLinkedFormPdfBlob(type, data) {
    if (!FORM_RENDERERS[type] || !data) return null;
    // page-1 so the page collector + first-page orientation pick it up as portrait.
    const { html: pagesHtml } = renderLinkedFormPages([{ type, data }], 1);
    // renderLinkedFormPages prefixes a <div class="page-break">; strip a leading one
    // (not needed for a standalone doc) but keep the page div intact.
    const body = pagesHtml.replace(/^\s*<div class="page-break"><\/div>/, '');
    const doc = `<!DOCTYPE html><html><head><meta charset="UTF-8">
        <title>${FORM_RENDERERS[type].title || 'Document'}</title>
        <style>${LINKED_FORM_STYLES}</style>
        </head><body><div class="pdf-container">${body}</div></body></html>`;
    return await renderPdfFromHtml(doc, 'preview', 'blob');
}

export async function previewJhaPdf(jhaData, crewMembers = [], options = {}) {
    const html = buildJhaPdfHtml(jhaData, crewMembers, options);
    return await renderPdfFromHtml(html, 'preview', 'window');
}

/**
 * Generate PDF and return as Blob for in-app preview
 * Use this for iPad/mobile to keep user in the app
 */
export async function generateJhaPdfBlob(jhaData, crewMembers = [], options = {}) {
    const html = buildJhaPdfHtml(jhaData, crewMembers, options);
    return await renderPdfFromHtml(html, 'preview', 'blob');
}

// Preload an image and return base64 data URL
async function preloadImage(src, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';

        const timer = setTimeout(() => {
            reject(new Error(`Image load timeout: ${src}`));
        }, timeout);

        img.onload = () => {
            clearTimeout(timer);
            try {
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataUrl = canvas.toDataURL('image/png');
                resolve(dataUrl);
            } catch (e) {
                reject(e);
            }
        };

        img.onerror = () => {
            clearTimeout(timer);
            reject(new Error(`Failed to load image: ${src}`));
        };

        // Add cache-busting for same-origin images
        img.src = src + (src.includes('?') ? '&' : '?') + '_t=' + Date.now();
    });
}

/**
 * Render PDF from HTML
 * @param {string} html - HTML content
 * @param {string} filename - Filename for download
 * @param {string} mode - 'download' | 'window' | 'blob'
 */
async function renderPdfFromHtml(html, filename, mode = 'download') {
    // Pre-load critical images before creating the DOM
    const imageCache = {};
    const imagesToPreload = [TENANT_LOGO_URL, '/images/energy_wheel.png'];

    console.log('Preloading images...');
    for (const src of imagesToPreload) {
        try {
            imageCache[src] = await preloadImage(src);
            console.log(`Loaded: ${src}`);
        } catch (e) {
            console.warn(`Failed to preload ${src}:`, e);
            imageCache[src] = null;
        }
    }

    // Replace image URLs with base64 data in HTML
    let processedHtml = html;
    for (const [src, dataUrl] of Object.entries(imageCache)) {
        if (dataUrl) {
            // Escape special regex characters in src
            const escapedSrc = src.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            processedHtml = processedHtml.replace(new RegExp(`src="${escapedSrc}"`, 'g'), `src="${dataUrl}"`);
        }
    }

    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.innerHTML = processedHtml;
    document.body.appendChild(container);

    try {
        // Additional wait for images already embedded as base64
        const images = container.querySelectorAll('img');
        await Promise.all(Array.from(images).map(img => {
            if (img.complete && img.naturalHeight > 0) return Promise.resolve();
            return new Promise(resolve => {
                img.onload = resolve;
                img.onerror = () => {
                    console.warn('Image failed to render:', img.src.substring(0, 50));
                    resolve();
                };
                // Fallback timeout
                setTimeout(resolve, 2000);
            });
        }));

        await new Promise(r => setTimeout(r, 200));

        // First page orientation = orientation of page-1 (JHA = landscape).
        const firstPageEl = container.querySelector('.page-1');
        const firstOrientation = (firstPageEl && firstPageEl.getAttribute('data-orientation')) || 'landscape';

        const pdf = new jsPDF({
            orientation: firstOrientation,
            unit: 'pt',
            format: 'letter'
        });

        const margin = 15;

        // Find all pages dynamically (page-1, page-2, page-3, etc.)
        const allPages = [];
        let pageNum = 1;
        while (true) {
            const page = container.querySelector(`.page-${pageNum}`);
            if (!page) break;
            allPages.push(page);
            pageNum++;
        }

        // Render each page, honoring its own orientation. JHA pages are landscape;
        // appended linked-form pages (FARP/CSEP/LTT) declare data-orientation="portrait"
        // so they render faithfully (pixel-perfect) at full portrait size.
        for (let i = 0; i < allPages.length; i++) {
            const page = allPages[i];
            const orientation = page.getAttribute('data-orientation') || 'landscape';

            if (i > 0) {
                pdf.addPage('letter', orientation);
            }

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const canvas = await html2canvas(page, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false
            });

            const imgData = canvas.toDataURL('image/png');
            const imgW = canvas.width / 2;
            const imgH = canvas.height / 2;

            const availW = pdfWidth - margin * 2;
            const availH = pdfHeight - margin * 2;
            // Scale to fit, preferring width-based scaling
            const scale = Math.min(availW / imgW, availH / imgH, 1);

            const w = imgW * scale;
            const h = imgH * scale;
            const x = (pdfWidth - w) / 2;
            const y = margin;

            pdf.addImage(imgData, 'PNG', x, y, w, h);
        }

        // Handle different output modes
        if (mode === 'blob') {
            // Return blob for in-app preview (iPad/mobile friendly)
            return pdf.output('blob');
        } else if (mode === 'window') {
            // Open in new window (desktop)
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(() => URL.revokeObjectURL(url), 30000);
            return true;
        } else {
            // Download file
            pdf.save(filename);
            return true;
        }
    } catch (error) {
        console.error('PDF generation failed:', error);
        throw error;
    } finally {
        document.body.removeChild(container);
    }
}

export default generateJhaPdf;
